<div class="container mx-auto px-4 py-8">
  <!-- En-tête -->
  <div class="mb-8">
    <h1 class="text-3xl font-bold text-gray-900 mb-4">Gestion des Écarts de Caisse</h1>
    <p class="text-gray-600">Gérez les écarts entre le montant réel dans la caisse et le montant enregistré dans le système.</p>
  </div>



  <!-- Statistiques -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" *ngIf="stats">
    <div class="bg-white rounded-lg shadow p-6">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-blue-100 text-blue-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600">Total Écarts</p>
          <p class="text-2xl font-semibold text-gray-900">{{ stats.totalDiscrepancies }}</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-yellow-100 text-yellow-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600">En Attente</p>
          <p class="text-2xl font-semibold text-gray-900">{{ stats.pendingDiscrepancies }}</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-green-100 text-green-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600">Approuvés</p>
          <p class="text-2xl font-semibold text-gray-900">{{ stats.approvedDiscrepancies }}</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <div class="flex items-center">
        <div class="p-3 rounded-full bg-red-100 text-red-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <p class="text-sm font-medium text-gray-600">Rejetés</p>
          <p class="text-2xl font-semibold text-gray-900">{{ stats.rejectedDiscrepancies }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Bouton de création -->
  <div class="mb-6">
    <button 
      (click)="toggleCreateForm()"
      class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200">
      <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      {{ showCreateForm ? 'Annuler' : 'Nouvel Écart' }}
    </button>
  </div>

  <!-- Formulaire de création -->
  <div class="bg-white rounded-lg shadow p-6 mb-8" *ngIf="showCreateForm">
    <h3 class="text-lg font-semibold text-gray-900 mb-4">Nouvel Écart de Caisse</h3>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Date</label>
        <input 
          type="datetime-local" 
          [(ngModel)]="createForm.date"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Montant Réel (MAD)</label>
        <input 
          type="number" 
          [(ngModel)]="createForm.realAmount"
          step="0.01"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Montant Système (MAD)</label>
        <input 
          type="number" 
          [(ngModel)]="createForm.systemAmount"
          step="0.01"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Écart Calculé (MAD)</label>
        <input 
          type="number" 
          [value]="calculateDiscrepancy()"
          readonly
          class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50">
      </div>
      
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-2">Commentaire (optionnel)</label>
        <textarea 
          [(ngModel)]="createForm.comment"
          rows="3"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Commentaire sur l'écart..."></textarea>
      </div>
    </div>
    
    <div class="mt-6 flex justify-end space-x-3">
      <button 
        (click)="toggleCreateForm()"
        class="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors duration-200">
        Annuler
      </button>
      <button 
        (click)="createDiscrepancy()"
        [disabled]="isLoading"
        class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors duration-200">
        <span *ngIf="isLoading" class="inline-block animate-spin mr-2">⟳</span>
        Créer l'Écart
      </button>
    </div>
  </div>

  <!-- Filtres -->
  <div class="bg-white rounded-lg shadow p-6 mb-8">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Filtrer par Statut</label>
        <select 
          [(ngModel)]="statusFilter"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="all">Tous les statuts</option>
          <option value="PENDING">En attente</option>
          <option value="APPROVED">Approuvé</option>
          <option value="REJECTED">Rejeté</option>
        </select>
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Filtrer par Date</label>
        <input 
          type="date" 
          [(ngModel)]="dateFilter"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>
    </div>
  </div>

  <!-- Liste des écarts -->
  <div class="bg-white rounded-lg shadow overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200">
      <h3 class="text-lg font-semibold text-gray-900">Liste des Écarts de Caisse</h3>
    </div>
    
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Montant Réel</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Montant Système</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Écart</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Créé par</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let discrepancy of getPaginatedDiscrepancies()" class="hover:bg-gray-50">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatDate(discrepancy.date) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatAmount(discrepancy.realAmount) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ formatAmount(discrepancy.systemAmount) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium" [ngClass]="getDiscrepancyClass(discrepancy.discrepancyAmount)">
              {{ formatAmount(discrepancy.discrepancyAmount) }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" [ngClass]="getStatusClass(discrepancy.status)">
                {{ getStatusLabel(discrepancy.status) }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ discrepancy.createdByUsername || 'N/A' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <div class="flex space-x-2">
                <button 
                  *ngIf="isAdmin && discrepancy.status === 'PENDING'"
                  (click)="approveDiscrepancy(discrepancy.id!)"
                  [disabled]="isLoading"
                  class="text-green-600 hover:text-green-900 disabled:opacity-50"
                  title="Approuver">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </button>
                <button 
                  *ngIf="isAdmin && discrepancy.status === 'PENDING'"
                  (click)="rejectDiscrepancy(discrepancy.id!)"
                  [disabled]="isLoading"
                  class="text-red-600 hover:text-red-900 disabled:opacity-50"
                  title="Rejeter">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
                <button 
                  *ngIf="isAdmin"
                  (click)="openEditForm(discrepancy)"
                  [disabled]="isLoading"
                  class="text-blue-600 hover:text-blue-900 disabled:opacity-50"
                  title="Modifier">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                <button 
                  *ngIf="isAdmin"
                  (click)="deleteDiscrepancy(discrepancy.id!)"
                  [disabled]="isLoading"
                  class="text-gray-600 hover:text-gray-900 disabled:opacity-50"
                  title="Supprimer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="getPaginatedDiscrepancies().length === 0">
            <td colspan="7" class="px-6 py-8 text-center text-gray-500">
              <div class="flex flex-col items-center">
                <svg class="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                <p class="text-lg font-medium text-gray-900 mb-2">Aucun écart de caisse trouvé</p>
                <p class="text-sm text-gray-600">Commencez par créer votre premier écart de caisse</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Paginator -->
    <div class="mt-6">
      <app-paginator
        [totalItems]="totalItems"
        [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage"
        [pages]="pages"
        [pagedItemsSize]="pagedItemsSize"
        (pageChange)="onPageChange($event)">
      </app-paginator>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
    <div class="bg-white p-8 rounded-lg shadow-xl">
      <div class="flex items-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span class="ml-3 text-gray-700">Chargement...</span>
      </div>
    </div>
  </div>

  <!-- Edit Form Modal - Clean & Responsive -->
  <div *ngIf="showEditForm" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
    <div class="w-full max-w-2xl bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden max-h-[90vh] flex flex-col">
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
        <div>
          <h2 class="text-xl font-semibold text-gray-900">Modifier l'Écart de Caisse</h2>
          <p class="text-sm text-gray-500">Mettre à jour les montants et le commentaire</p>
        </div>
        <button (click)="closeEditForm()" class="p-2 rounded-full text-gray-500 hover:bg-gray-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="px-6 py-5 space-y-5 overflow-y-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Montant Réel (MAD)</label>
            <input
              type="number"
              [(ngModel)]="editForm.realAmount"
              step="0.01"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="0.00">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Montant Système (MAD)</label>
            <input
              type="number"
              [(ngModel)]="editForm.systemAmount"
              step="0.01"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="0.00">
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Écart Calculé (MAD)</label>
          <input
            type="number"
            [value]="calculateEditDiscrepancy()"
            readonly
            class="w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-800">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Commentaire</label>
          <textarea
            [(ngModel)]="editForm.comment"
            rows="3"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Ajoutez des détails ou des notes..."></textarea>
        </div>
      </div>

      <!-- Footer -->
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex flex-col sm:flex-row sm:justify-end gap-3">
        <button
          (click)="closeEditForm()"
          class="px-5 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100">
          Annuler
        </button>
        <button
          (click)="saveEditForm()"
          [disabled]="isLoading"
          class="px-5 py-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center">
          <span *ngIf="!isLoading" class="inline-flex items-center">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Enregistrer
          </span>
          <span *ngIf="isLoading" class="inline-flex items-center">
            <svg class="w-5 h-5 mr-2 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Enregistrement...
          </span>
        </button>
      </div>
    </div>
  </div>
  <!-- Delete Confirmation Dialog -->
  <app-confirmation-dialog
    [isVisible]="showDeleteConfirmation"
    [title]="'Confirmer la suppression'"
    [message]="'Êtes-vous sûr de vouloir supprimer cet écart ? Cette action est irréversible.'"
    [confirmText]="'Supprimer'"
    [cancelText]="'Annuler'"
    [type]="'danger'"
    (confirm)="onDeleteConfirm()"
    (cancel)="onDeleteCancel()"
    (close)="onDeleteCancel()">
  </app-confirmation-dialog>
</div>